import { NgClass, NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogButtonConfig } from '../dialog/dialog.component';

const SlideOverButtonStyles: { [key: string]: string } = {
	normal: 'normalSlideButton tw-inline-flex tw-ml-3 tw-justify-center tw-rounded-md tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-300 focus:tw-ring-1 hover:tw-bg-gray-50 sm:tw-mt-0 sm:tw-w-auto',
	primary: 'primarySlideButton tw-inline-flex tw-ml-3 tw-justify-center tw-rounded-md tw-bg-primary tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-primary2 sm:tw-w-auto',
	danger: 'dangerSlideButton tw-inline-flex tw-ml-3 tw-justify-center tw-rounded-md tw-bg-red-600 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-red-500 sm:tw-w-auto',
	caution: 'cautionSlideButton tw-inline-flex tw-ml-3 tw-justify-center tw-rounded-md tw-bg-amber-400 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-amber-500 sm:tw-w-auto',
};

@Component({
	selector: 'mos-slide-over',
	templateUrl: './slide-over.component.html',
	imports: [NgComponentOutlet, NgClass, NgTemplateOutlet, MatTooltipModule],
	standalone: true,
})
export class SlideOverComponent {
	public isOpen: boolean = false;
	@Input() public slideOverHeader: any;
	@Input() public slideOverContent: any;
	@Input() public buttons: DialogButtonConfig[];

	@ContentChild('content') public content: TemplateRef<any>;
	@ContentChild('header') public header: TemplateRef<any>;

	@Output() public opened = new EventEmitter<void>();
	@Output() public closed = new EventEmitter<void>();

	constructor() {}

	public close(): void {
		this.isOpen = false;
		this.closed.emit();
	}

	public open(): void {
		this.isOpen = true;
		this.opened.emit();
	}

	protected readonly SlideOverButtonStyles = SlideOverButtonStyles;
}
